/* eslint-disable monsterverse-rules/no-uuid-literals */
export const AudioAssets = {
  DolphinJump1: "64ebe5a9-7cd1-42f2-b21a-5363dad68d09",
  DolphinJump2: "00ce5341-29e9-45cb-a64d-d3417b1d0a51",
  DolphinJump3: "de6844f5-1a7f-4efc-8784-f6de2993f53c",
  MonsterTada: "c2300604-05c0-4232-87c4-afefa266a54e",
  Splash1: "558b5b4d-8ade-43c4-af2a-382a37f89750",
  Splash2: "538b306a-4c39-460f-a1c7-c4330c035ee9",
  Splash3: "98e29278-bd07-4f9b-8d61-f7fe4a742fc8",
  Splash4: "624c2195-9a99-4058-b3a7-dc4b82055f21",
  // WhaleAttach1: "30ba6cff-c08c-4637-ab54-e24f1141910c",
  // WhaleAttach2: "647e147d-9009-4f78-9d57-aff9ae818781",
  // WhaleAttach3: "aed0402a-c4a3-4e0f-930a-d074849d9553",
  correctB1: "664a0dbc-eaf1-41be-9864-a878807576d4",
};
